import React, { useState } from "react";
import "./SellerBuyers.css";
import SellerImg from "../assets/images/SellerImg.png";
import { Typewriter } from "react-simple-typewriter";


const SellerBuyers = ({ FAQDATA, headingshow }) => {
  const [selected, setSelected] = useState(0);
  const toggle = (i) => {
    if (selected == i) {
      return setSelected(null);
    }
    setSelected(i);
  };


  return (
    <div className="seller">
      <div className="container px-3">
        <div className="text-center py-4 py-md-5">
          {!headingshow && (
            <h1
              style={{
                fontFamily: "'Plus Jakarta Sans', sans-serif",
              }}
            >
              Made with love for

              <span style={{ position: "relative", display: "inline-block", marginLeft: "8px" }}>
                <span
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "50%",
                    backgroundColor: "#FFE500",
                    zIndex: -1,
                    marginTop: "20px",
                  }}
                ></span>
                <Typewriter
                  words={["Sellers", "Buyers"]} // Ensure words are strings
                  loop={0}
                  cursor
                  cursorStyle="!"
                  typeSpeed={70}
                  deleteSpeed={90}
                  delaySpeed={2000}
                />
              </span>
              {/* <span style={{ color: "#D9D9D9" }}> Buyers</span> */}
            </h1>
          )}
        </div>

        <div className="row">
          <div className="col-lg-6">
            <div>
              <img src={SellerImg} className="img-fluid" />
            </div>
          </div>

          <div className="col-lg-6 px-lg-5 d-flex flex-column justify-content-center mt-5 mt-lg-0">
            <div className="FAQ-main">
              <div className="accordian">
                {headingshow && <h1>The Real Estate Transactions</h1>}
                {FAQDATA?.map((item, i) => (
                  <div className="item" key={i}>
                    <div className="title" onClick={() => toggle(i)}>
                      <div className="title-inner ">
                        {selected === i ? (
                          <h5 className="text-theme-white  font-face-PlusJakartaSans-Bold ">
                            {item.heading}
                          </h5>
                        ) : (
                          <h5 className=" text-theme-white font-face-PlusJakartaSans-Bold">
                            {item.heading}
                          </h5>
                        )}
                        {/* {selected === i ? (
                                                    <img src={CrossIcon} alt="icon" />

                                                ) : (
                                                    <img src={PlusIcon} alt="icon1" />

                                                )} */}
                      </div>

                      <div
                        className={selected == i ? "content show" : "content"}
                      >
                        <div className="">
                          <div className="row d-md-flex align-items-center">
                            <div className="col-md-12">
                              <p className="text-theme-light-white font-face-PlusJakartaSans-Regular description-ethicalessence">
                                {item.description}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SellerBuyers;
